import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { PeriodicElement } from "../analytics-display-list/analytics-display-list.component";
import { LoggingService } from "app/shared";

@Component({
  selector: "analytics-display-list-simple",
  templateUrl: "./analytics-display-list-simple.component.html",
  styleUrl: "./analytics-display-list-simple.component.css",
  standalone: false,
})
export class AnalyticsDisplayListSimpleComponent implements OnChanges, OnInit {
  private _logger: LoggingService;

  @Input() listData: any[] = [];

  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedColumns: string[] = [];
  expandedRows = new Set<PeriodicElement>();

  constructor(private logger: LoggingService) {
    this._logger = logger;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["listData"] && changes["listData"].currentValue) {
      this.updateTable();
    }
  }

  private updateTable(): void {
    this._logger.log(
      "AnalyticsDisplayList-Simple-Component.updateTable - listData:",
      this.listData
    );

    if (this.listData.length > 0) {
      const allKeys = Object.keys(this.listData[0]);

      // Separate regular columns and action columns
      const actionColumns = allKeys.filter((key) =>
        key.startsWith("__action_")
      );

      const regularColumns = allKeys.filter(
        (key) => !key.startsWith("__action_")
      );

      // Combine regular columns first, then action columns
      this.displayedColumns = [...regularColumns, ...actionColumns];
    } else {
      this.displayedColumns = [];
    }

    this.dataSource.data = this.listData; // Update the data source
  }

  toggleRow(row: PeriodicElement): void {
    if (this.expandedRows.has(row)) {
      this.expandedRows.delete(row);
    } else {
      this.expandedRows.add(row);
    }
  }

  isRowExpanded(row: any): boolean {
    return this.expandedRows.has(row);
  }

  ngOnInit(): void {
    this.updateTable();
  }
}
